
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Cpts005 from '@/components/public-components/cpts005/index.vue'
import collect from '@/components/lyx-components/new-collection/index.vue'
import './index.less'

import util from '@/javascript/util'
import EsQuery from '@/javascript/esQuery'
import { formatDate } from "@/javascript/formatDate"
import history from '@/components/lyx-components/new-history/index.vue'
import payPublic from '@/javascript/payPublic'
import share from '@/components/lyx-components/share/index.vue'
import bus from '@/javascript/bus'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
directives: {
TransferDom
},
computed: {
titleImage(){
if(this.detailContent && this.detailContent.titleImageUrl && this.detailContent.titleImageUrl.includes('http')){
return this.detailContent.titleImageUrl
}else{
return this.PIC_BASE_URL + this.detailContent.titleImageUrl
}
}
},
components: {
Previewer,
Cpts005,
collect,
history,
share,
goBack,
Footer
},
data() {
return {
isWeixin: util.isWeiXin(),
minHeight: 0,
textContentHeight: '40rem',
detailContent: {},
recommendTags: {},
recommendList: [],
imgList: [],
strategyEntity: {},
collectParams: {},
history: '',
isLogin: false,
keyData: new Date().getTime(),
sharePage: {}
}
},
created() {
const _this = this

_this.initData()
},
mounted() {
this.minHeight = document.documentElement.clientHeight
},
watch: {
"$route": {
handler() {
this.textContentHeight = '40rem'
this.initData()
}
}
},
methods: {
showMoreContent: function () {
this.textContentHeight = 'auto'
},
showViewer: function (e) {
e = e || window.event
const target = e.target || e.srcElement
const imgList = document.getElementsByClassName('content-box')[0].querySelectorAll('img')

for (let i in imgList) {
if (target === imgList[i]) {
this.$refs.previewer.show(parseInt(i))
}
}
},
initData: function () {
const _this = this
payPublic.checkLogin(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo) {
_this.isLogin = true
} else {
_this.isLogin = false
}
_this.keyData = new Date().getTime()
})

/**
* 详情内容
*/
_this.$http.get(`api/wtcp-traveltips/public/notes/findById/${_this.$route.params.id}`).then(response => {
_this.detailContent = response.data.data.notesEntity
_this.detailContent.updatedDate = formatDate(_this.detailContent.updatedDate, 'yyyy-MM-dd')
const noteTags = response.data.data.noteTags
noteTags.forEach(item => {
if (item.tagCatagory == '地区') {
_this.recommendTags.area = item.tagName
}
if (item.tagCatagory == '玩法') {
_this.recommendTags.tag = item.tagName
}
})

const resData = response.data.data.notesEntity,
strategyEntity = {}

strategyEntity.titleImageUrl = resData.titleImageUrl
strategyEntity.serviceType = 200
strategyEntity.summary = resData.summary
strategyEntity.title = resData.title

_this.collectParams = {
catalog: _this.XQSC_TYPE_CODE.YJ, //类别
picUrl: resData.titleImageUrl, //图片URL
principalId: resData.id, //被收藏对象id
serviceType: _this.SERVICE_TYPE.YJ, //浏览信息所属的服务类型
summary: (resData.summary == null) ? resData.subTitle : resData.summary, //简介
title: resData.title, //浏览信息页面的标题
articleSite: window.location.pathname + window.location.hash, //浏览页面信息的地址
},

_this.history = {
catalog: _this.XQSC_TYPE_CODE.YJ,
serviceType: _this.SERVICE_TYPE.YJ,
summary: (resData.summary == null) ? resData.subTitle : resData.summary, //简介
title: resData.title,
url: window.location.pathname + window.location.hash,
picUrl: resData.titleImageUrl
}

_this.sharePage = {
url: window.location.href,
title: resData.title,
image: resData.titleImageUrl ? _this.PIC_BASE_URL + resData.titleImageUrl : this.SHARE_IMG,
desc: resData.summary ? resData.summary : this.SHARE_TEXT
}


_this.strategyEntity = strategyEntity

}).then(() => {
_this.keyData = new Date().getTime()
document.title = _this.detailContent.title
/**
* 微信签名分享
*/
if (_this.isWeixin) {
const shareData = typeof (shareData) === 'undefined' ? {
title: _this.detailContent.title ? _this.detailContent.title : _this.PAGE_TITLE,
desc: _this.detailContent.summary ? _this.detailContent.summary : _this.SHARE_TEXT,
imgUrl: _this.detailContent.titleImageUrl ? _this.PIC_BASE_URL + _this.detailContent.titleImageUrl : _this.SHARE_IMG,
link: window.location.href
} : shareData
_this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + _this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}


if (bus.userInfo.user) {
const userInfo = bus.userInfo.user,
history = {
catalog: _this.XQSC_TYPE_CODE.YJ,
serviceType: _this.SERVICE_TYPE.YJ,
title: _this.detailContent.subTitle,
url: _this.$route.path,
userId: userInfo.id,
username: userInfo.username,
picUrl: _this.detailContent.titleImageUrl
}
bus.$set(bus, 'history', history)
} else {
console.log('token过期了呀');
}

const imgList = document.getElementsByClassName('content-box')[0].querySelectorAll('img')
const imgList2 = []
if (imgList.length > 0) {
imgList.forEach(item => {
imgList2.push({
src: item.src
})
})
_this.imgList = imgList2
}

/**
* 关联资源
*/





















if (_this.$refs.contentBox.offsetHeight < parseInt(_this.textContentHeight.substring(0, _this.textContentHeight.length - 2)) * 50) {
_this.textContentHeight = 'auto'
}

/**
* 推荐阅读
*/
const recommendEsQuery = new EsQuery()
if (_this.recommendTags.area) {
recommendEsQuery.addString("tags", _this.recommendTags.area, recommendEsQuery.and, false)
}
if (_this.recommendTags.tag) {
recommendEsQuery.addString("tags", _this.recommendTags.tag, recommendEsQuery.and, false)
}
recommendEsQuery.addPage(0, 3)
const querystring = require('querystring');
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: 'wtcp-note',
esJsonQuery: recommendEsJsonQuery
})).then(response => {
if (!response.data.data) {
return
}
_this.recommendList = response.data.data

let flag = -1
_this.recommendList.forEach((item, index) => {
if (item._id == _this.detailContent.id) {
flag = index
}
})
if (flag > -1) {
_this.recommendList.splice(flag, 1)
}
})
})

/**
* 访问量
*/
_this.$http.get(`/api/wtcp-traveltips/public/notes/click/${_this.$route.params.id}`).then(response => {
})
},
fatherMethod() {
const _this = this
payPublic.toLogin(function () {
const userInfo = JSON.parse(localStorage.getItem('userInfo'))
if (userInfo) {
_this.isLogin = true
} else {
_this.isLogin = false
}
_this.keyData = new Date().getTime()
})
}
}
}
